//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import AkLinkEditing from "./akLinkEditing";
import AkLinkUi from "./akLinkUi";

export default class AkLink extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [AkLinkEditing, AkLinkUi];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AkLink";
  }
}
